import { TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthService } from 'app/login/services/auth.service';
import { Role } from 'app/shared/models/role';
var HasPermissionDirective = /** @class */ (function () {
    function HasPermissionDirective(templateRef, viewContainer, authService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.authService = authService;
    }
    Object.defineProperty(HasPermissionDirective.prototype, "hasPermission", {
        set: function (role) {
            var _this = this;
            if (this._userSubscription) {
                this._userSubscription.unsubscribe();
            }
            this._userSubscription = this.authService.getLoginState().subscribe(function (loginState) {
                var user = loginState.user;
                _this.viewContainer.clear();
                if (user && user.role <= Role[role]) {
                    _this.viewContainer.createEmbeddedView(_this.templateRef);
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    HasPermissionDirective.prototype.ngOnDestroy = function () {
        if (this._userSubscription) {
            this._userSubscription.unsubscribe();
        }
    };
    return HasPermissionDirective;
}());
export { HasPermissionDirective };



// WEBPACK FOOTER //
// ./src/app/login/has-permission/has-permission.ts.pre-build-optimizer.js